import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import SmartToyIcon from "@material-ui/icons/EmojiObjects";
import PaymentIcon from "@material-ui/icons/Payment";
import TelegramIcon from "@material-ui/icons/Telegram";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4, 0),
    textAlign: "center",
  },
  label: {
    color: "#58EFFE",
    fontSize: "0.76rem",
    fontWeight: 700,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginBottom: theme.spacing(3),
  },
  track: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: { gap: theme.spacing(1) },
  },
  partner: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: theme.spacing(0.9, 1.8),
    borderRadius: 999,
    border: "1px solid rgba(255, 255, 255, 0.06)",
    background: "rgba(255, 255, 255, 0.03)",
    backdropFilter: "blur(8px)",
    color: "rgba(255, 255, 255, 0.4)",
    fontSize: "0.85rem",
    fontWeight: 600,
    transition: "all 0.35s ease",
    "&:hover": {
      borderColor: "rgba(88, 239, 254, 0.2)",
      color: "#ffffff",
      background: "rgba(255, 255, 255, 0.06)",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-2px)",
    },
  },
  stats: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: theme.spacing(5),
    [theme.breakpoints.down("sm")]: { gap: theme.spacing(3) },
  },
  stat: {
    textAlign: "center",
    minWidth: 120,
  },
  statNumber: {
    display: "block",
    fontSize: "clamp(2rem, 4.5vw, 3rem)",
    fontWeight: 800,
    background: "linear-gradient(135deg, #58EFFE, #39F3CC)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    lineHeight: 1.1,
  },
  statLabel: {
    color: "rgba(255, 255, 255, 0.4)",
    fontSize: "0.8rem",
    fontWeight: 600,
    marginTop: 6,
    letterSpacing: "0.04em",
  },
}));

const partners = [
  { name: "WhatsApp Business", icon: WhatsAppIcon },
  { name: "Meta Business", icon: FacebookIcon },
  { name: "Instagram", icon: InstagramIcon },
  { name: "OpenAI GPT-4", icon: SmartToyIcon },
  { name: "Stripe", icon: PaymentIcon },
  { name: "Telegram", icon: TelegramIcon },
];

const stats = [
  { number: "99.9%", label: "Uptime garantizado" },
  { number: "24/7", label: "Soporte disponible" },
  { number: "256-bit", label: "Encriptación TLS" },
  { number: "GDPR", label: "Cumplimiento" },
];

export default function PartnersSection({ resolveText }) {
  const classes = useStyles();

  return (
    <section className={`${classes.root} gsap-fade-in`}>
      <p className={classes.label}>
        {resolveText("landing.partners.label") !== "landing.partners.label"
          ? resolveText("landing.partners.label")
          : "Integrado con las mejores plataformas"}
      </p>

      <div className={classes.track}>
        {partners.map((p) => {
          const Icon = p.icon;
          return (
            <div key={p.name} className={classes.partner}>
              <Icon fontSize="small" />
              <span>{p.name}</span>
            </div>
          );
        })}
      </div>

      <div className={classes.stats}>
        {stats.map((s) => (
          <div key={s.label} className={classes.stat}>
            <span className={classes.statNumber}>{s.number}</span>
            <span className={classes.statLabel}>{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
